<template>
    <div>
        <div ref="chartdiv" :style="{ height: height, width: width }">
        </div>
    </div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import { EventBus } from '../../event/event-bus.js';
    export default {
        inject: ['globalColourMap'],
        name: 'LineChart',
        props: {
            width: {
                default: "auto",
                type: String
            },
            height: {
                default: "350px",
                type: String
            },
            title: {
                default: "",
                type: String
            },
            data: {
                default: () => [],
                type: Array
            },
            type: {
                default: "column",
                type: String
            },
            scrollView: {
                default: true,
                type: Boolean
            },
            fontSize: {
                default: 14,
                type: Number
            },
            opacity: {
                default: 100,
                type: Number
            },
            stack: {
                default: true,
                type: Boolean
            },
            legend: {
                default: false,
                type: Boolean
            },
            bullet: {
                default: false,
                type: Boolean
            }

        },
        watch: {
            deep: true,
            immediate: true,
            data() {
                this.render();
            },
            title(val) {
                this.titleObj.text = val;
                this.titleObj.fontSize = 20;
            },
            type() {
                this.chart.dispose();
                this.render();
            },
            legend() {
                this.chart.dispose();
                this.render();
            },
            bullet() {
                this.chart.dispose();
                this.render();
            },
            opacity(val) {
                this.seriesArr.forEach((series) => {
                    series.fillOpacity = val / 100;
                });
            },
            stack(val) {
                this.seriesArr.forEach((series) => {
                    series.stacked = val;
                });
            },
            scrollView() {
                this.chart.dispose();
                this.render();
            }
        },
        data: function () {
            return {
                seriesArr: [],
                titleObj: {},
                chart: null,
            }
        },
        created() {
            EventBus.$on('emit-theme-change', ()  =>  {
                this.refreshTheme();
            });
        },
        mounted() {
            this.render();
        },
        methods: {
            async render() {
               
                this.seriesArr = [];

                if (!this.data || this.data.length === 0) return;
                this.chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

                this.chart.paddingRight = 20;

                this.chart.fontSize = this.fontSize;

                this.titleObj = this.chart.titles.create();

                const keys = Object.keys(this.data[0]).filter(key => key !== "x");

                //check for placeholders we will be able to get count of total
                this.titleObj.text = this.title.replace("{count}", keys.length);
                this.titleObj.fontSize = 20;
                this.titleObj.marginBottom = 20;

                this.chart.data = this.data;

                this.chart.tooltip.label.maxWidth = 150;
                this.chart.tooltip.label.wrap = true;

                if (this.legend) {
                    this.chart.legend = new am4charts.Legend();
                    this.chart.legend.useDefaultMarker = true;
                    this.chart.legend.maxHeight = 100;
                    this.chart.legend.scrollable = true;
                    var marker = this.chart.legend.markers.template.children.getIndex(0);
                    marker.cornerRadius(12, 12, 12, 12);
                    marker.strokeWidth = 2;
                    marker.strokeOpacity = 1;
                    marker.stroke = am4core.color("#ccc");
                }

                let xAxis = this.chart.xAxes.push(new am4charts.DateAxis());
                xAxis.renderer.grid.template.location = 0;
                xAxis.logarithmic = true;

                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.tooltip.disabled = true;
                valueAxis.renderer.minWidth = 35;

              

                keys.forEach((key) => {
                    var chartType = this.getChartType()
                    let series = this.chart.series.push(chartType);
                    series.dataFields.dateX = "x";
                    series.dataFields.valueY = key;
                    series.tooltipText = `${key} : {${key}}`;
                    series.stacked = this.stack;

                    series.name = key;
                    series.fillOpacity = this.opacity / 100;
                    this.seriesArr.push(series);
                    series.tensionX = 0.77;
                    series.strokeWidth = 2;

                    if (this.bullet) {
                        var bullet = series.bullets.push(new am4charts.CircleBullet());
                        bullet.circle.radius = 3;
                    }
                    var i = this.globalColourMap.nameToInt(key);
                    series.fill = series.chart.colors.list[i];
                    series.stroke = series.chart.colors.list[i];
                    
                });

                this.chart.cursor = new am4charts.XYCursor();
            },
            getChartType() {
                switch (this.type) {
                    case "column":
                        return new am4charts.ColumnSeries();
                    case "series":
                        return new am4charts.LineSeries();
                    case "3d column":
                        return new am4charts.ColumnSeries3D();
                    case "curved column":
                        return new am4charts.CurvedColumnSeries();
                    default:
                        return new am4charts.ColumnSeries();
                }
            },
            dispose() {
                if (this.chart) {
                    this.chart.dispose();
                }
            },
            async refreshTheme() {
                await this.render();
            }
        },
        beforeDestroy() {
            this.dispose();
        }
    }
</script>
